module.exports = __webpack_public_path__ + "img/News.svg.370c735d.png";